import React, { ReactNode, useState, useEffect, Suspense, useRef } from "react";
import { Box, Grid, Typography, useTheme, Skeleton } from "@mui/material";
import { AccessTimeOutlined, CrisisAlertOutlined, LocalMallOutlined } from "@mui/icons-material";
import { Link, useParams, useSearchParams } from "react-router-dom";
// import ClientComponent from "@components/ClientComponent";
import Footer from "@layouts/Footer";
import HorizontalLinearStepper from "../donate/components/LinearStepper";
import CountDownTimer from "@components/CountDownTimer";
import ShadowedButton from "@components/ShadowedButton";
import Notification from "@components/Notification";
import { DeservingCandidateEligibility } from "@interfaces/DeservingItem";
import { NotificationProperties } from "@interfaces/Notification";
import { sendEvent } from "@utilities/googleAnalytics";
import { GoogleAnalyticsEvents } from "@constants/googleAnalyticsEvents";
import Description from "@pages/public/donate/components/CampaignDescription";
import MoreCampaigns from "@pages/public/donate/components/MoreCampaigns";
// import CampaignHeader from "@pages/public/donate/components/CampaignHeader";
import { Dayjs } from "dayjs";
import { handleDonateClick } from "@utilities/facebookPixel";

const CampaignKeyItem = ({ label, value, icon }: { label: string; value: string; icon: ReactNode }) => {
    const theme = useTheme();
    return (
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-start"} height={70}>
            <Box display={"flex"} alignItems={"center"}>
                {icon}
                <Typography fontSize={{ xs: 13, sm: 16 }} lineHeight={"24px"} color={theme.palette.grey[700]} ml={1}>
                    {label}
                </Typography>
            </Box>
            <Typography fontSize={{ xs: 16, sm: 24 }}>{value}</Typography>
        </Box>
    );
};
interface Donor {
    // Timezone offset
    id: number;
    name: string;
    avatarUrl: string;
    lastDonationTime: Dayjs | string;
}
interface CampaignData {
    title: string;
    slug: string;
    description: string;
    video_link: string;
    video_des: string;
    payment_description: string;
    image_url_2: string;
    amount_goal: number;
    raised_amount_in_bdt: number;
    start_date: string;
    end_date?: string; // Optional
    is_published?: boolean;
    show_patients_list?: boolean;
    showInstruments_list?: boolean;
    showResearch_list?: boolean;
    allowGeneralDonation?: boolean;
    donors?: Donor[];
    accept: boolean;
    modal: boolean;
    offline: boolean;
    amount: boolean;
    payment_method: boolean;
    autopay: boolean;
}

interface CampaignProps {
    campaignData: {
        success: boolean;
        total_count: number;
        current_page_number: number;
        item_per_page: number;
        message: string;
        data?: CampaignData; // Mark `data` as optional
    } | null;
}

const Campaign: React.FC<CampaignProps> = ({ campaignData }) => {
    const { slug } = useParams();
    const [queryParams] = useSearchParams();
    const isAccepted = queryParams.get("accept");
    const isPaymentMethod = queryParams.get("payment_method");
    const isAutopay = queryParams.get("autopay");
    const isAmount = queryParams.get("amount");
    const fb = queryParams.get("modal");
    const [data, setData] = useState<CampaignData | null>(campaignData?.data || null);
    const [campaignErrorMessage, setCampaignErrorMessage] = useState<string>("");
    const [notification, setNotification] = useState<NotificationProperties>({ isOpen: false, message: "", type: "success" });

    const [isCampaignEnded, setIsCampaignEnded] = useState<boolean>(false);
    const [published, setPublished] = useState<boolean>(true);
    // const [donateNow, setDonateNow] = useState<boolean>(false);
    const [donateNow, setDonateNow] = useState<boolean>(
        campaignData?.data?.modal ||
            campaignData?.data?.accept ||
            campaignData?.data?.offline ||
            campaignData?.data?.payment_method ||
            campaignData?.data?.autopay ||
            false
    );
    const [deservingCandidateEligibility, setDeservingCandidateEligibility] = useState<DeservingCandidateEligibility>({
        showPatients: false,
        showInstrument: false,
        showResearch: false,
        allowGeneralDonation: false,
    });
    // Create a ref for the Box
    // Add HTMLDivElement type to the ref
    const boxRef = useRef<HTMLDivElement>(null);

    const handleFocusBox = () => {
        if (boxRef.current) {
            boxRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };
    const redirect = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_WEB_URL}/zakat-fund-all-bank-accounts`;
    };
    const redirect1 = () => {
        window.location.href = `${process.env.REACT_APP_API_BASE_WEB_URL}/poor-fund-all-bank-accounts`;
    };

    const fetchCampaignData = async () => {
        try {
            console.log("Fetching campaign data for slug:", slug);
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${API_BASE_URL}/campaigns/${slug}`);
            const newData = await response.json();

            // Log fetched data

            // Only update data if the fetched slug matches the current slug

            // Update state with fetched data
            setData(newData.data);

            // setDeservingCandidateEligibility({
            //     showPatients: Boolean(newData.data.show_patients_list),
            //     showInstrument: Boolean(newData.data.showInstruments_list),
            //     showResearch: Boolean(newData.data.showResearch_list),
            //     allowGeneralDonation: Boolean(newData.data.allowGeneralDonation),
            // });
        } catch (error) {
            console.error("Error fetching campaign data:", error);
        }
    };

    useEffect(() => {
        console.log("checking slug", slug);
        // Fetch data only if slug has changed
        if (!data || data.slug !== slug) {
            console.log("Slug  mismatch,so update");
            fetchCampaignData();
            if (isAccepted) {
                setDonateNow(true);
            }
            if (fb) {
                setDonateNow(true);
            }
            if (isPaymentMethod) {
                setDonateNow(true);
            }
            if (isAutopay) {
                setDonateNow(true);
            }
        }

        // Update eligibility only when `data` is available
        if (data) {
            console.log("data-campaign", data.title);
            // setDeservingCandidateEligibility({
            //     showPatients: Boolean(data.show_patients_list),
            //     showInstrument: Boolean(data.showInstruments_list),
            //     showResearch: Boolean(data.showResearch_list),
            //     allowGeneralDonation: Boolean(data.allowGeneralDonation),
            // });
        }
    }, [slug, data]); // Only re-run if `slug` or `data` changes
    const handleDonation = (donateNowClicked: boolean) => {
        setDonateNow(donateNowClicked);
        console.log("donateNowClicked", donateNowClicked);
    };

    const [isSticky, setIsSticky] = useState(false);

    // Scroll event handler
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setIsSticky(true); // Becomes sticky after 300px scroll
            } else {
                setIsSticky(false); // Goes back to normal position before 300px
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div>
            {/* <Box sx={{ backgroundColor: "transparent" }}> */}
            {/* Normal Header */}
            <Box
                style={{
                    position: "relative", // Always relative for normal header
                    top: isSticky ? "-100px" : "0", // Slide out of screen when sticky
                    backgroundColor: "#fff",
                    transition: "top 0.5s ease-out, opacity 0.5s ease-out", // Smooth transition for top and opacity
                    opacity: isSticky ? 0 : 1, // Fade out normal header when sticky
                    width: "100%", // Full width
                    zIndex: isSticky ? -1 : 1, // Lower z-index to hide behind sticky header
                    boxShadow: isSticky ? "none" : "0 4px 10px rgba(0, 0, 0, 0.05)", // Shadow when normal header
                }}
            >
                {/* <CampaignHeader /> */}
                <style>
                    {`
                            @keyframes slideIn {
                                0% {
                                    opacity: 0;
                                    transform: translateY(-100%);
                                }
                                100% {
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }
                        `}
                </style>
            </Box>

            {/* Sticky Header */}
            {isSticky && (
                <Box
                    style={{
                        position: "fixed", // Fixed position for sticky effect
                        top: "0", // Stick at the top of the page
                        zIndex: 1000, // Ensure it's above everything else
                        backgroundColor: "#fff",
                        animation: "slideIn 0.5s ease-out forwards", // Apply keyframe animation
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)", // Light shadow effect when sticky
                        width: "100%", // Full width
                    }}
                >
                    {/* <CampaignHeader /> */}
                    <style>
                        {`
                            @keyframes slideIn {
                                0% {
                                    opacity: 0;
                                    transform: translateY(-100%);
                                }
                                100% {
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }
                        `}
                    </style>
                </Box>
            )}
            {/* </Box> */}

            {data ? (
                <div style={{ backgroundColor: "#f5f8fa" }}>
                    <Grid item xs={12}>
                        {campaignErrorMessage.length > 0 ? (
                            <Grid item xs={12}>
                                <Suspense fallback={<Skeleton variant="rectangular" width="100%" height={300} />}>
                                    {/* <CampaignErrorPage message={campaignErrorMessage} icon={campaignErrorIcon} /> */}
                                </Suspense>
                            </Grid>
                        ) : (
                            <>
                                {/* Campaign Banner */}
                               

                                {/* Deserving Candidate Eligibility */}
                                <Grid item xs>
                                    <HorizontalLinearStepper
                                        showDialog={donateNow}
                                        // deservingCandidateEligibility={deservingCandidateEligibility}
                                        ImageUrl={data.image_url_2}
                                        title={data.title}
                                        description={data.payment_description}
                                        onClick={handleDonation}
                                    />
                                </Grid>
                               

                                

                              

                         
                            </>
                        )}
                    </Grid>
                </div>
            ) : (
                <div>Loading Campaign Details...</div> // Fallback while loading
            )}
        </div>
    );
};

export default Campaign;
